module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/zh-hans/6-1c8660162d8723f6f04b98844c4170d5.jpg";